export { DefaultErrorSection } from './404';
